import billingApiModule from '../billingApi.module';

class BillingProductApiService {
    constructor(__env, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    getProducts() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/products`
        );
    }
}

export default billingApiModule.service(
    'billingProductApiService',
    BillingProductApiService
);



// WEBPACK FOOTER //
// ./modules/billingApi/product/billingProductApi.service.js